// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__19Kfq","cell":"ColumnAccessor_cell__3MXj2","firstCellAccent":"ColumnAccessor_firstCellAccent__86YHY"};